module.exports = __webpack_public_path__ + "img/flecha-hacia-abajo.48e61599.svg";